import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { GoogleMap, Marker } from "@react-google-maps/api";

import { googleMapLoader } from '../../../helpers/googleMapLoader';

import originMarker from '/public/Icons/userMarkerPin.svg';

const refs = {}
class ShowMap extends Component {
    static defaultProps = {
        zoom: 4,
        height: '400px',
        width: '100%',
    };

    constructor(props) {
        super(props);
        this.state = {
            center: {
                lat: 37.0902,
                lng: -95.7129
            },
            googleMapsApiLoaded: false
        };
    }

    async componentDidMount() {
        const { id, initialValue } = this.props;
        this.setState({ value: initialValue });
        const autocompleteService = await googleMapLoader();
        this.setState({ googleMapsApiLoaded: true });
        this.autocompleteService = autocompleteService;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { lat, lng, stepTwoCompleted } = nextProps;
        let center;
        if (lat && lng && stepTwoCompleted) {
            center = {
                lat,
                lng
            };
            this.setState({
                center
            })
        }
    }

    onPolygonLoad = (map) => {
        const { stepTwoCompleted, sw_lat, sw_lng, ne_lat, ne_lng } = this.props;
        let bounds = new google.maps.LatLngBounds();
        let southWest, northEast;
        if (stepTwoCompleted && map && sw_lat && sw_lng && ne_lat && ne_lng) {
            southWest = new google.maps.LatLng(sw_lat, sw_lng);
            northEast = new google.maps.LatLng(ne_lat, ne_lng);
            bounds.extend(southWest);
            bounds.extend(northEast);
            map.fitBounds(bounds);
        }
        refs.map = map;
    }

    render() {
        const { height, width, lat, lng, zoom, stepTwoCompleted } = this.props;
        const { center, googleMapsApiLoaded } = this.state;
        let mapStyles = [
            {
                featureType: "poi",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#eeeeee",
                    },
                ],
            },
            {
                featureType: "poi",
                elementType: "labels.text",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "water",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        color: "#9e9e9e",
                    },
                ],
            },
        ];


        return (
            googleMapsApiLoaded ?
                <div>
                    <GoogleMap
                        ref={(map) => this.map = map}
                        zoom={zoom}
                        center={center}
                        mapContainerStyle={{ height, width }}
                        onLoad={this.onPolygonLoad}
                        onBoundsChanged={this.onPolygonLoad(refs.map)}
                        options={{
                            styles: mapStyles,
                            disableDefaultUI: true,
                            zoomControl: true,
                            zoomControlOptions: {
                                position: google.maps.ControlPosition.LEFT_BOTTOM
                            }
                        }}
                    >
                        {lat && lng && stepTwoCompleted && <Marker
                            position={new google.maps.LatLng(lat, lng)}
                            icon={originMarker}
                        />}
                    </GoogleMap>
                </div> : <></>
        )
    }
}

const mapState = state => ({});

const mapDispatch = {
    change
};

export default connect(mapState, mapDispatch)(ShowMap);